import { render, staticRenderFns } from "./CollarLeashColorSelect.vue?vue&type=template&id=55ae9142&scoped=true&"
import script from "./CollarLeashColorSelect.vue?vue&type=script&lang=js&"
export * from "./CollarLeashColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./CollarLeashColorSelect.vue?vue&type=style&index=0&id=55ae9142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae9142",
  null
  
)

export default component.exports